import classNames from 'classnames';
import DotshorizontalIcon from 'icons/Dotshorizontal.icon';
import { Button, Dropdown } from 'ncoded-component-library';
import React, { FC, useCallback } from 'react';
import { DropdownOption } from 'models/Dropdown';
import useCallbackRef from 'hooks/useCallbackRef';
import { DropdownRef } from 'ncoded-component-library/build/components/molecules/Dropdown/Dropdown.component';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { IconProp } from 'models/Icon';

import './MoreDropdown.styles.scss';

type MoreOption = DropdownOption & {
  to?: string;
  icon?: IconProp;
};

type MoreDropdownProps = {
  className?: string;
  options: MoreOption[];
  trigger?: JSX.Element;
};

const MoreDropdown: FC<MoreDropdownProps> = (props) => {
  const {
    className,
    options,
    trigger = <Button icon={DotshorizontalIcon} />,
  } = props;

  const [dropdown, dropdownRef] = useCallbackRef<DropdownRef>();

  const classes = classNames('more-dropdown', className);

  const { t } = useTranslation();

  const closeDropdown = useCallback(
    () => dropdown?.setIsOpen(false),
    [dropdown],
  );

  return (
    <Dropdown
      renderAsPortal
      ref={dropdownRef}
      className={classes}
      trigger={trigger}
    >
      <ul className="more-dropdown__content">
        {options.map(({ label, to, alert, disabled, icon: Icon, onClick }) => (
          <li key={label} onClick={closeDropdown}>
            {to ? (
              <Link to={to} className={classNames({ disabled, alert })}>
                {Icon && <Icon />}
                {t(label)}
              </Link>
            ) : (
              <Button
                variant="link"
                className={classNames({ disabled, alert })}
                onClick={onClick}
              >
                {Icon && <Icon />}
                {t(label)}
              </Button>
            )}
          </li>
        ))}
      </ul>
    </Dropdown>
  );
};

export default MoreDropdown;
